import React, { useEffect, useState, useRef } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";
import getBaseUri from "./getBaseUri";

const GetNavLink = ({ menuLocation = "header-menu" }) => {
  const [menuItems, setMenuItems] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false); // State for menu toggle
  const menuRef = useRef(null); // Ref for the menu container
  // const mockMenuItems = [
  //   { id: 1, title: "Home", url: "/" },
  //   { id: 2, title: "About", url: "/about" },
  //   { id: 3, title: "Services", url: "/services" },
  //   { id: 4, title: "Contact", url: "/contact" },
  // ];
  useEffect(() => {
    const fetchMenu = async () => {
      const baseUri = getBaseUri();

      try {
        const response = await axios.get(
          `${baseUri}/wp-json/custom/v1/menu/${menuLocation}`
        );
        setMenuItems(response.data);
      } catch (err) {
        console.error("Error fetching menu:", err);
        setError("Unable to fetch menu data.");
      } finally {
        // setLoading(false);
      }
    };

    fetchMenu();
  }, [menuLocation]);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev); // Toggle menu open/close state
  };

  useEffect(() => {
    // Close the menu if user scrolls
    const handleScroll = () => {
      if (isMenuOpen) {
        setIsMenuOpen(false); // Close the menu when scrolling
      }
    };

    // Close the menu if user clicks outside the menu
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsMenuOpen(false); // Close the menu when clicking outside
      }
    };

    // Add event listeners for scroll and click
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("click", handleClickOutside);

    return () => {
      // Clean up event listeners
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("click", handleClickOutside);
    };
  }, [isMenuOpen]);

  // if (loading) {
  //   return <p>Loading menu...</p>;
  // }

  if (error && process.env.NODE_ENV !== "development") {
    return <p>{error}</p>;
  }

  return (
    <div className="menu-container" ref={menuRef}>
      <button className="menu-button" onClick={toggleMenu}>
        MENU <span className="plus-sign">{isMenuOpen ? "-" : "+"}</span>
      </button>
      <div
        className={`dropdown-menu ${isMenuOpen ? "open" : ""}`}
        style={{ maxHeight: isMenuOpen ? "300px" : "0" }}
      >
        <ul>
          {menuItems.map((item) => (
            <li key={item.id}>
              <NavLink
                to={item.url.replace(window.location.origin, "")}
                className={({ isActive }) =>
                  `nav-link ${isActive ? "active" : ""}`
                }
              >
                {item.title}
              </NavLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default GetNavLink;
